import React from 'react';
import './FiltersList.scss';
import bem from '../../utils/bem';
import { ANIMATIONS } from '../../utils/constants';
import { useState } from 'react';
import { useEffect } from 'react';
  const FiltersList = ({ options, selected, onChange }) => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) { // Cambia 100 al valor de desplazamiento deseado
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={`filters-list ${isSticky ? 'sticky' : ''}`}>
      <ul className="filters-list__options">
        {options.map(option => (
          <li className="filters-list__option" key={option.value}>
            <button
              className={`filters-list__option-button ${
                selected?.value === option.value ? 'selected' : ''
              }`}
              onClick={() => onChange(option)}
            >
              {option.label}
            </button>
            <span className="filters-list__option-placeholder" />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FiltersList;